import React from 'react';
import { createPortal } from 'react-dom';
import { Trash2, RefreshCw, X } from 'lucide-react';

interface DeleteBackupModalProps {
  isOpen: boolean;
  filename: string | null;
  isDeleting: boolean;
  onClose: () => void;
  onConfirmDelete: (filename: string) => void;
}

export const DeleteBackupModal: React.FC<DeleteBackupModalProps> = ({
  isOpen,
  filename,
  isDeleting,
  onClose,
  onConfirmDelete,
}) => {
  if (!isOpen || !filename) return null;

  const modalContent = (
    <div className="fixed inset-0 z-[999] flex items-center justify-center p-3 sm:p-4 bg-slate-900/60 backdrop-blur-xs animate-in fade-in duration-150 overflow-y-auto">
      <div className="bg-white rounded-2xl max-w-md w-full p-4 sm:p-5 shadow-2xl border border-rose-100 space-y-3 animate-in zoom-in-95 duration-150 relative my-auto">
        <button
          type="button"
          onClick={onClose}
          disabled={isDeleting}
          className="absolute top-3.5 right-3.5 p-1 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition cursor-pointer"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="flex items-center gap-2.5 text-rose-600 pr-6">
          <div className="p-2 rounded-xl bg-rose-50 border border-rose-200 shrink-0">
            <Trash2 className="w-5 h-5 text-rose-600" />
          </div>
          <div className="min-w-0">
            <h3 className="text-sm sm:text-base font-bold text-slate-900 leading-tight">
              Konfirmasi Hapus File Backup
            </h3>
            <p className="text-[11px] text-rose-600 font-medium">Tindakan tidak dapat dibatalkan</p>
          </div>
        </div>

        <div className="p-3 rounded-xl bg-rose-50/60 border border-rose-200 text-xs text-slate-700 space-y-1.5">
          <p className="font-semibold text-slate-900">
            Apakah Anda yakin ingin menghapus berkas cadangan berikut dari server?
          </p>
          <p className="font-mono text-[11px] font-bold text-rose-900 bg-white px-2 py-1 rounded border border-rose-200 break-all leading-snug">
            {filename}
          </p>
          <p className="text-[10px] text-slate-500">
            Berkas backup yang dihapus tidak dapat dipulihkan kembali dari server.
          </p>
        </div>

        <div className="flex items-center justify-end gap-2 pt-2 border-t border-slate-100">
          <button
            type="button"
            onClick={onClose}
            disabled={isDeleting}
            className="px-3.5 py-1.5 rounded-xl text-xs font-semibold text-slate-600 hover:bg-slate-100 transition cursor-pointer"
          >
            Batal
          </button>

          <button
            type="button"
            onClick={() => onConfirmDelete(filename)}
            disabled={isDeleting}
            className="px-3.5 py-1.5 rounded-xl bg-rose-600 hover:bg-rose-700 text-white text-xs font-bold shadow-xs flex items-center gap-1.5 transition cursor-pointer disabled:opacity-50"
          >
            {isDeleting ? (
              <>
                <RefreshCw className="w-3.5 h-3.5 animate-spin" />
                <span>Menghapus...</span>
              </>
            ) : (
              <>
                <Trash2 className="w-3.5 h-3.5" />
                <span>Ya, Hapus File Backup</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};
